module.exports = __webpack_public_path__ + "img/bandera_eua.7288e189.svg";